// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__KzaVY","footer":"ModalInfo_footer__3TSJv"};